import { useSyncExternalStore } from 'react';
import { getTenantRuntime, type TenantRuntime } from '../config/tenant';

// Shared, memory-only cockpit selection. A new runtime discards the previous tenant's selection.
let snapshot: { runtime: TenantRuntime; selectedProperties: ReadonlySet<string> } | undefined;
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
function getSnapshot() {
  const runtime = getTenantRuntime();
  if (snapshot?.runtime !== runtime) snapshot = { runtime, selectedProperties: new Set(runtime.properties.map(property => property.key)) };
  return snapshot;
}
export function usePropertySelection() {
  const { selectedProperties } = useSyncExternalStore(subscribe, getSnapshot);
  const toggleProperty = (key: string) => {
    const current = getSnapshot();
    const next = new Set(current.selectedProperties);
    if (next.has(key)) next.delete(key); else next.add(key);
    snapshot = { runtime: current.runtime, selectedProperties: next };
    listeners.forEach(listener => listener());
  };
  return { selectedProperties, toggleProperty };
}

/**
 * House selection as the backend filter (#613 Variante A): undefined while every house is selected (nothing is filtered),
 * otherwise the selected codes plus "ohne-standort", so rows without a house are never filtered out.
 */
export function locationsQuery(selected: ReadonlySet<string>, all: ReadonlyArray<{ key: string }>): string | undefined {
  return all.every(property => selected.has(property.key)) ? undefined : [...[...selected].sort(), 'ohne-standort'].join(',');
}
